(function (root) {
"use strict";
var K = typeof module !== "undefined" && module.exports ? require("./sudaderotas-kit.js") : root.SDRKit;
if (!K) return;
if (typeof module !== "undefined" && module.exports) require("./sudaderotas-tejido.js");
var T = K.tej; if (!T) return;
var CB = { b: "#fff6ec", R: "#e23c52", o: "#f7c64a", a: "#7fb4e8", c: "#a8703f" };
var RENO_GRANDE = [
"..c...c.......",
"..cc.cc.......",
"...ccc........",
"....cc........",
"...cccc.......",
"..cccocc......",
"..ccccccccccc.",
"...cccccccccccc",
"...ccccccccccc.",
"...c.c.....c.c",
"...c.c.....c.c",
"...b.b.....b.b"];
var CRG = { c: "#fff6ec", o: "#14244a", b: "#e23c52" };
function defs() { return K.defsComunes() + T.defs(); }
function cols(w) { return Math.ceil(w / T.CW) + 1; }
function bandaRenos(fila0, n, x0) {
x0 = x0 || 0;
var CR = { b: "#c8283f" }, o = '<rect x="' + x0 * T.CW + '" y="' + fila0 * T.CH + '" width="' + n * T.CW + '" height="' + 10 * T.CH + '" fill="url(#tejB)"/>';
o += T.banda(fila0, ["b"], n, null, x0, CR) + T.banda(fila0 + 9, ["b"], n, null, x0, CR);
for (var x = x0 + 1; x < x0 + n; x += 16) { o += T.motivo(T.MOTIVOS.reno, x, fila0 + 1, CR) + T.motivo(T.MOTIVOS.copo.slice(1, 6).map(function (r) { return r.slice(0, 5); }), x + 13 - 2, fila0 + 2, { b: "#2f9e6a" }); }
return o;
}
function frente() {
var n = cols(1000) + 34, b = K.fondo("url(#tejN)") + bandaRenos(1, n, -17) +
T.banda(15, ["..o.........", "............", ".......b....", "............"], n, null, -17, CB) +
T.banda(26, [".......b....", "............", "..o.........", "............"], n, null, -17, CB) +
T.franja(43, n, "#9c1830", T.MOTIVOS.zig, CB, -17);
return K.svgSangrado(defs(), b);
}
function espalda() {
var n = cols(1000) + 34, b = K.fondo("url(#tejN)") +
T.banda(8, ["b"], n, null, -17, CB) + T.banda(9, ["....o......."], n, null, -17, CB) + T.banda(10, ["b"], n, null, -17, CB) +
T.motivo(RENO_GRANDE.map(function (r) { return r.split("").reverse().join(""); }), 4, 12, CRG) + T.motivo(RENO_GRANDE, 23, 12, CRG) +
T.motivo(T.MOTIVOS.copo, 18, 13, CB) +
bandaRenos(37, n, -17);
return K.svgSangrado(defs(), b);
}
function manga() {
var n = cols(600), b = '<rect width="600" height="1400" fill="url(#tejN)"/>' + bandaRenos(2, n) + bandaRenos(41, n) +
T.banda(16, ["..o.........", "............", ".......b....", "............"], n, null, 0, CB) + T.banda(28, [".......b....", "............", "..o.........", "............"], n, null, 0, CB);
return K.svg(600, 1400, defs(), b);
}
function capucha() {
var b = '<rect width="900" height="900" fill="url(#tejN)"/>', n = cols(900);
for (var y = 3; y < 34; y += 9) for (var x = (y / 9 | 0) % 2 ? 2 : 7; x < n; x += 10) b += T.motivo(T.MOTIVOS.copo, x, y, CB);
return K.svg(900, 900, defs(), b);
}
var D = {
id: "renos", nombre: "Suéter de renos", max: 3, despuesDe: "tejida",
arte: { frente: frente, espalda: espalda, manga: manga, capucha: capucha },
fondo: function (ctx, w, h) {
ctx.fillStyle = "#14244a"; ctx.fillRect(0, 0, w, h);
for (var y = 0; y < h; y += T.CH) for (var x = 0; x < w; x += T.CW) T.puntada(ctx, x, y, T.CW, T.CH, "#26407a", false);
},
resorte: function (ctx, x, y, w, h) {
var u = h / 70, paso = 10 * u;
for (var i = 0, xx = x; xx < x + w; xx += paso, i++) {
var g = ctx.createLinearGradient(xx, 0, xx + paso, 0), c = i % 4 < 2 ? ["#9c1830", "#e23c52"] : ["#14244a", "#26407a"];
g.addColorStop(0, c[0]); g.addColorStop(.5, c[1]); g.addColorStop(1, c[0]); ctx.fillStyle = g; ctx.fillRect(xx, y, paso + 1, h);
}
},
dibujar: {
frente: function (ctx, estado, fotos, K) {
var A = K.A, cajas = K.mascotas(ctx, estado, fotos, 690, [.92, .84, .76]);
cajas.forEach(function (b) { K.astas(ctx, b); K.bufanda(ctx, b.x + b.w / 2, b.y + b.h * .84, b.w * .78); });
K.letras(ctx, K.capital(estado.frase), 500, 335, 96, 660, "#fff6ec", "#9c1830", { borde: "#9c1830" });
T.texto(ctx, A.nombres(estado), 990, "#fff6ec", 640, true);
},
espalda: function (ctx, estado, fotos, K) {
var A = K.A;
T.texto(ctx, A.nombres(estado) || "Mi mascota", 710, "#ffffff", 660, true);
T.texto(ctx, "NAVIDAD " + K.anio(), 885, "#f7c64a", 700, true);
}
}
};
if (typeof module !== "undefined" && module.exports) module.exports = D; else K.registrar(D);
})(this);